import { HttpClient, HttpHeaders, HttpUrlEncodingCodec } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { OccEndpointsService } from "@spartacus/core";
import { Observable } from "rxjs";


export interface PunchOutSession {
  customerId: string;
  cartId: string;
  punchOutLevel: string;
  punchOutOperation: string;
  selectedItem: string;
  token: PunchOutToken;
}

export interface PunchOutToken {
  accessToken: String;
  tokenType: String;
}

@Injectable({
  providedIn: 'root',
})
export class PunchOutService {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) { }

  getPunchOutSessionData(
    sid: string,
    key: string
  ): Observable<PunchOutSession> {
    ['isLoggedInPayer','defaultLocInList','defaultLocation','selectedLocations','productAllocations'].forEach(token => sessionStorage.removeItem(token));
    ['formularyCustomer', 'YFAuthorized', 'blockOrder','punchout-sid-key','spartacus⚿vsh⚿cart','spartacus⚿vax⚿cart'].forEach(token => localStorage.removeItem(token));
    // localStorage.clear();
    // sessionStorage.clear();
    localStorage.setItem('punchout-sid-key', sid);
    const codec = new HttpUrlEncodingCodec();
    const keyValue = encodeURIComponent(key);
    const sidValue = encodeURIComponent(sid);
    const url = this.occEndpoints.buildUrl('punchout/session/punchoutlogin');
    return this.http.post<any>(
      url,
      {
        key: keyValue,
        sid: sidValue,
      },
      httpOptions
    );
  }
}

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

